<template>
  <!--票务系统-->
  <article>
    <div class="caption">
      <h2>票务系统</h2>
      <span>TICKETING SYSTEM</span>
    </div>

    <div class="content">
      票务系统是未来整合其他系统的灵魂所在，景区票务是景区外部运营及营销推广结果导向第一触达体现。<br />
      票务系统的架构精细化决定了未来的多层次销系统、大数据分析系统、域内流量统计系统、社会化服务系统、运维服务体系的数据完整性和准确率
    </div>

    <div class="grid">
      <div v-for="item in data" :key="item.title" class="item">
        <img :src="item.img" alt="" srcset="">
        <h4>{{item.title}}</h4>
        <h5>{{item.subtitle}}</h5>
        <p>{{item.content}}</p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data: function() {
    return {
      data: [
        {
          img: require("@/assets/images/product/ticket/item-1.png"),
          title: "扫码购票系统",
          subtitle: "Scan Code Ticket",
          content:
            "弱化窗口功能，加强网络购票途径、节省人力成本、节约纸质票制作成本、减少二次排队，免注册快速购票、支持高并发下购票、DIY定制二维码展示"
        },
        {
          img: require("@/assets/images/product/ticket/item-2.png"),
          title: "多终端集成检票系统",
          subtitle: "Multi-terminal Integration",
          content:
            "拒绝唯一，灵活多变。实现闸机、手持验票机、验票一体机、手机小程序验票、手机APP验票（安卓、ios）多方位验票方式"
        },
        {
          img: require("@/assets/images/product/ticket/item-3.png"),
          title: "后台管理系统",
          subtitle: "Background Management",
          content:
            "拥有灵活可配置的管理功能，并支持多级分层管理功能，让权责划分清晰，专业的人做专业的事。丰富的报表管理模式，让数据会说话，走出业务增长困境，拉升业务增长"
        },
        {
          img: require("@/assets/images/product/ticket/item-4.png"),
          title: "财务管理系统",
          subtitle: "Financial Management",
          content:
            "多种支付模式管理（微信、支付宝、银联卡），可配置自动对账管理功能，全面对接国内主流银行支付系统、国际VISA、MasterCard支付系统的完整聚合支付"
        },
        {
          img: require("@/assets/images/product/ticket/item-5.png"),
          title: "全票种管理",
          subtitle: "Full-ticket Management",
          content:
            "对景区门票进行精细化动态管理，将散客票、团队票、特殊团体票、免票人群进行动态调整，支持自主打包产品模块来满足不同景区管理者针对自身景区政策进行设定"
        },
        {
          img: require("@/assets/images/product/ticket/item-6.png"),
          title: "电子发票",
          subtitle: "Electronic Invoice",
          content:
            "支付开票可以节省售票员全部开发票时间，解放前台开票人员！一切发票工作全部交由游客一键自助申请，发票流转通过微信、支付宝、短信、邮件等形式，安全可靠"
        },
        {
          img: require("@/assets/images/product/ticket/item-7.png"),
          title: "离线售票",
          subtitle: "Offline Ticketing",
          content:
            "无论是人为原因或者网络物理环境的错综复杂导致终端出现离线情况。一旦出现网络中断，就会导致无法进行正常的票务操作，造成游客积聚滞留，此时离线售票系统是作为应急方案的支撑"
        },
        {
          img: require("@/assets/images/product/ticket/item-8.png"),
          title: "多证件识别",
          subtitle: "Multiple Identification",
          content:
            "目前可以支持港澳台身份识别、护照识别、交通一卡通、养老助残卡，多证件识别可以帮助景区对于游客更加友好，快速减少景区和游客之间的差别感，提升友好感官以及消除距离感"
        },
        {
          img: require("@/assets/images/product/ticket/item-9.png"),
          title: "游客风控管理",
          subtitle: "Tourist Control Management",
          content:
            "为景区量身打造的游客风控系统，针对个别对景区有破坏性、危害景区安全、倒买倒卖景区门票的重点人群设置黑名单，系统本身具有防刷单、防黄牛的扩展功能"
        },
        {
          img: require("@/assets/images/product/ticket/item-10.png"),
          title: "OTA分销",
          subtitle: "OTA Distribution",
          content:
            "对接数据准确率达到100%，目前OTA接口标准各有不同，导致景区对接数据出现偏差，增加和方面对账核销工作量，目前我司系统支持所有分销渠道全方面接口程序对接"
        },
        {
          img: require("@/assets/images/product/ticket/item-11.png"),
          title: "分时限流",
          subtitle: "Time-sharing Current",
          content:
            "为提升景区服务质量，配合景区引导客流。给游客提供优质的参观体验，提升游客安全指数，告别粗框的半日制限流模式，我司率先提出分时预约支持精确到“时”级为单位，支持场次单位"
        },
        {
          img: require("@/assets/images/product/ticket/item-12.png"),
          title: "演出锁座",
          subtitle: "Performance Locke",
          content:
            "配合景区内实景演出、场馆演出等场景下需求，提供景区在高并发下实现毫秒级锁座机制，提升游客参观体验度，满足不同场景下需求，避免演出时出现重复锁座等困扰减少投诉率"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

article {
  display: flex;
  flex-direction: column;

  > .caption {
    display: flex;
    flex-direction: column;
    align-items: center;
    > h2 {
      display: inline-block;
      border-bottom: 2px solid #666666;
      padding-bottom: 5px;
    }

    span {
      font-size: 14px;
      font-weight: lighter;
    }
  }

  > .content {
    margin: 20px 0;
    text-align: center;
    font-size: 14px;
  }

  > .grid {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    > .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 24%;
      padding: 40px;
      // border: 1px solid blue;

      > img {
        width: 75px;
        height: 75px;
        margin: 20px 0;
      }

      > h4 {
        font-size: 18px;
        font-weight: bold;
      }

      > h5 {
        font-size: 14px;
        font-weight: lighter;
        margin-bottom: 15px;
        text-align: center;
      }

      > p {
        font-size: 0.06rem;
        line-height: 0.12rem;
      }
    }
  }
}
</style>